"use client";

import { QuestsPage } from "./QuestsPage";

export function QuestsPageWrapper() {
  return <QuestsPage />;
}